import uuid from 'uuid/v4'

export function emptyButton ({ type = 'ITEM', buttonText = '', index, buttonSize = 'SMALL' } = {}) {
  return {
    id: uuid(),
    index,
    entityType: 'MENU_LAYOUT_MENU_BUTTON',
    type,
    typeInfo: {
      itemInfo: {
        departmentId: null,
        itemId: null,
        sizeId: null,
        sizeOptionId: null,
        styleId: null,
        styleOptionId: null,
        menuLinkId: null,
        showImage: false
      },
      modifierInfo: {
        modifierItemId: null,
        departmentId: null,
        sizeId: null,
        sizeOptionId: null,
        styleId: null,
        styleOptionId: null,
        menuLinkId: null,
        showImage: false
      },
      sizeInfo: {
        departmentId: null,
        sizeId: null,
        sizeOptionId: null
      },
      styleInfo: {
        departmentId: null,
        styleId: null,
        styleOptionId: null
      },
      messageId: null,
      tenderInfo: {
        tenderTypeId: 1,
        isExactAmount: true,
        amount: '1.00',
        orderType: null
      },
      menuLinkId: null,
      specialFunctionInfo: {
        function: 'OPEN_DRAWER',
        itemSearch: {
          restrictToCategory: false,
          departmentId: null,
          categoryId: null,
          searchBy: 'NAME'
        }
      },
      offerInfo: {
        offerId: null,
        showImage: false
      }
    },
    buttonText: buttonText.substr(0, 25),
    buttonStyle: {
      buttonSize,
      forceSquared: false,
      buttonColor: '#306090',
      textColor: '#FFF',
      textStyle: [],
      textFont: 'Helvetica Neue, Helvetica',
      textSize: 'NORMAL',
      buttonImage: null
    }
  }
}

export function emptyLayoutTab (order = -1) {
  return {
    entityType: 'LAYOUT_TAB',
    id: uuid(),
    name: '',
    hideName: false,
    order,
    limitDays: {
      enabled: false,
      days: []
    },
    limitHours: {
      enabled: false,
      startTime: 28800,
      endOffset: 54000
    },
    limitStations: {
      enabled: false,
      stations: []
    },
    visible: true,
    active: true,
    tabImage: null,
    tabColor: '#306090',
    tabTextColor: '#FFF',
    background: {
      mode: 'COLOR',
      color: '#FFFFFF',
      imageId: null,
      imageSize: 'auto auto'
    },
    scrollingText: {
      enabled: false,
      message: '',
      fontSize: 12,
      style: [],
      color: '#000000',
      placement: 'BOTTOM',
      animation: 'STATIC'
    },
    buttons: {}
  }
}
